import React, { useState, useContext, Component, createRef } from "react";
import CartContext from "./CartContext";
import { Link } from "react-router-dom";
import { Country, State, City } from "country-state-city";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { LoadSpinner } from "./LoadSpinner";

import {
  Modal,
  Row,
  Col,
  Nav,
  FloatingLabel,
  Form,
  Button,
  Alert,
  Container,
} from "react-bootstrap";

export default class UserProfile extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      userData: {},
      ResultStatusText: "",
      validated: false,
      isAccountCreated: false,
      showModel: false,
      firstLoad: false,
      loadSpinnerOpen: false,
    };
  }

  handleInputChange = (e, index) => {
    const { name, value } = e.target;

    switch (name) {
      case "businessName":
        this.state.userData.businessName = value;
        break;

      case "firstName":
        this.state.userData.firstName = value;
        break;

      case "emailId":
        this.state.userData.emailId = value;
        break;
      case "contactNo":
        if (value.toString().length < 11) this.state.userData.contactNo = value;
        break;
      case "gstin":
        this.state.userData.gstin = value;
        break;
      case "businessPanNumber":
        this.state.userData.businessPanNumber = value;
        break;
      case "address":
        this.state.userData.address = value;
        break;
      case "pinCode":
        this.state.userData.pinCode = value;
        break;
      case "city":
        this.state.userData.city = value;
        break;
      case "state":
        this.state.userData.state = value;
        break;
      case "country":
        this.state.userData.country = value;
        break;
    }
    this.setState({ userData: this.state.userData });
    this.setState({ ResultStatusText: "" });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  GetUserData = () => {
    this.ShowLoadSpinner();
    console.log(`Bearer ${this.context.userData.bearerToken}`);

    var requestData = "";
    if (this.context.GetEcSettingValueByName("loginMethod") == "SMS") {
      requestData =
        "Sales/GetTenantBycontactNo/" + this.context.userData.contactNo;
    } else if (this.context.GetEcSettingValueByName("loginMethod") == "EMAIL") {
      requestData = "Sales/GetTenantByEmailId/" + this.context.userData.emailId;
    } else return;

    fetch(
      process.env.REACT_APP_API + requestData,

      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${this.context.userData.bearerToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        data = JSON.parse(data);
        if (data.country == null)
          data.country = this.context.GetEcSettingValueByName("defaultCountry");
        if (data.state == null)
          data.state = this.context.GetEcSettingValueByName("defaultState");
        data.bearerToken = this.context.userData.bearerToken;
        this.setState({ userData: data });

        this.context.storeUserData(data);
        console.log(data);
        this.HideLoadSpinner();
      })
      .catch((error) => {
        console.error("There was an error!", error);
        this.HideLoadSpinner();
      });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.context.userData.loginStatus === "active") {
      if (this.state.firstLoad == false) {
        this.state.firstLoad = true;
        this.GetUserData();
      }
    }
  }

  SaveUserProfile() {
    fetch(process.env.REACT_APP_API + "Sales/UpdateTenant/", {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.state.userData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404 || data.status == 400) {
          this.setState({
            ResultStatusText: "Unable to Save. try later!",
          });
          return;
        }
        console.log("User profile updated success");
        this.setState({
          ResultStatusText: "Saved Successfully!",
        });
        this.context.storeUserData(data);
        return;
      })
      .catch((error) => {
        console.error("There was an error!", error);
        alert("Error while Save:" + error);
      });
  }

  ValidateExtra = () => {
    var phoneValid = true;
    if (
      this.state.userData.contactNo.toString().length !==
      Number(this.context.GetEcSettingValueByName("phoneNumberLength"))
    ) {
      this.state.userData.contactNo = "";
      this.setState({ userData: this.state.userData });
      phoneValid = false;
    }

    if (phoneValid == true) {
      return true;
    } else {
      return false;
    }
  };

  handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false || this.ValidateExtra() === false) {
      event.stopPropagation();
    } else {
      this.SaveUserProfile();
    }
    this.setState({ validated: true });
  };

  render() {
    if (this.context.userData.loginStatus != "active")
      return <Navigate to="/home" />;

    return (
      <>
        <>
          <div
            className="Container-fluid mx-0 px-1 bg-white"
            style={{ paddingTop: "65px", marginLeft: "100px" }}
          >
            {this.state.loadSpinnerOpen === true ? (
              <LoadSpinner open="true"></LoadSpinner>
            ) : (
              ""
            )}
            <div className="row mt-2 mx-1 px-0">
              <div className="col-md-3 "></div>
              <div className="col-md-6  ">
                <>
                  <h3>
                    <b>My Profile</b>
                  </h3>
                  <Form
                    noValidate
                    validated={this.state.validated}
                    onSubmit={this.handleSubmit}
                  >
                    <div className=" ">
                      <Row className="py-1">
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationCustom01"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="First Name *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="text"
                              name="firstName"
                              placeholder="First Name *"
                              className="bg-white"
                              size="lg"
                              required
                              value={this.state.userData.firstName}
                              onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter First Name
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationCustom01"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Last Name *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="text"
                              name="lastName"
                              className="bg-white"
                              size="lg"
                              required
                              value={this.state.userData.lastName}
                              onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a Last Name
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Row>
                      <Row className="py-1">
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationCustom03"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="contactNo Number*"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="text"
                              name="contactNo"
                              placeholder="contactNo No *"
                              className="bg-white"
                              size="lg"
                              required
                              disabled={
                                this.context.GetEcSettingValueByName(
                                  "loginMethod"
                                ) == "SMS"
                                  ? true
                                  : false
                              }
                              value={this.state.userData.contactNo}
                              onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid{" "}
                              {this.context.GetEcSettingValueByName(
                                "phoneNumberLength"
                              )}
                              digit Phone Number!
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationCustom04"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Email ID *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="email"
                              name="emailId"
                              placeholder="Email address *"
                              required
                              disabled={
                                this.context.GetEcSettingValueByName(
                                  "loginMethod"
                                ) == "EMAIL"
                                  ? true
                                  : false
                              }
                              className="bg-white"
                              size="lg"
                              value={this.state.userData.emailId}
                              onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter a valid Email ID.
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Row>
                      <Row className="py-1">
                        <Form.Group
                          as={Col}
                          md="8"
                          controlId="validationCustom07"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Full Address *"
                            className="mb-3 moveLabelUp "
                          >
                            <Form.Control
                              type="text"
                              name="address"
                              size="lg"
                              required
                              placeholder="Full Address *"
                              value={this.state.userData.address}
                              onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter address
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom11"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="City *"
                            className="mb-3  "
                          >
                            <Form.Control
                              type="text"
                              name="city"
                              placeholder="City *"
                              size="lg"
                              required
                              className="bg-white"
                              value={this.state.userData.city}
                              onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter City
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Row>
                      <Row className="pd-3">
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom09"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Country *"
                            className="mb-3  "
                          >
                            <Form.Select
                              value={this.state.userData.country}
                              name="country"
                              // size="lg"
                              required
                              // disabled
                              onChange={this.handleInputChange}
                            >
                              <option value=""></option>
                              {Country.getAllCountries().map((country) => (
                                <>
                                  <option value={country.isoCode}>
                                    {country.name}
                                  </option>
                                </>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              Please select country
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom10"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="State *"
                            className="mb-3  "
                          >
                            <Form.Select
                              value={this.state.userData.state}
                              name="state"
                              required
                              onChange={this.handleInputChange}
                            >
                              <option></option>
                              {State.getStatesOfCountry(
                                this.state.userData.country
                              ).map((s1) => (
                                <>
                                  <option>{s1.name}</option>
                                </>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              Please select State
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom07"
                        >
                          <FloatingLabel
                            controlId="floatingInput"
                            label="Pincode *"
                            className="mb-3 moveLabelUp "
                          >
                            <Form.Control
                              type="text"
                              name="pinCode"
                              size="lg"
                              required
                              placeholder="pinCode *"
                              value={this.state.userData.pinCode}
                              onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter PinCode
                            </Form.Control.Feedback>
                          </FloatingLabel>
                        </Form.Group>
                      </Row>
                      <br></br>
                      <Row className="text-center">
                        <h5 className="blink_me text-black">
                          {this.state.ResultStatusText}
                        </h5>
                      </Row>
                      <Row>
                        <Col className="text-center">
                          <Button variant="primary" type="submit" size="lg">
                            Update
                          </Button>
                        </Col>
                      </Row>
                      <br></br>
                    </div>
                  </Form>
                  <Modal
                    show={this.state.showModel}
                    onHide={this.handleModelClose}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Signup Status</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Signup Success!</Modal.Body>
                    <Modal.Footer>
                      <Button variant="primary" onClick={this.handleModelClose}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </>
              </div>
            </div>
          </div>
        </>
      </>
    );
  }
}
